export default "mutation addCategory($addRequest: ResourceTagCategoryAddRequest) {\n  addCategory(addRequest: $addRequest) \n}";